import { TitleBar } from "../components/TitleBar";
import '../assets/YouthFlagRugby.css';

export const YouthFlagRugbyPage = () => {
    return (
        <>
            <TitleBar title="K-8 Flag Rugby"/>
            <p>Silicon Valley Rugby is starting flag rugby in Sunnyvale for K-8 players.</p>
            <p>
                Flag rugby is easy to learn, fast, and fun to play. No contact, just running forward, passing
                backward, pulling flags, scoring tries.
            </p>
            <p>
                See this overview: <a target="_blank" rel="noreferrer" href="https://www.youtube.com/watch?v=RgPICwPIEYs">https://www.youtube.com/watch?v=RgPICwPIEYs</a>
            </p>
            <div className='title'>Schedule</div>
            <ul>
                <li>Sunday afternoons at Sunnyvale fields near you.</li>
                <li>Elementary students: 2:00 PM &ndash; 3:30 PM</li>
                <li>Middle School students: 3:30 PM &ndash; 5:00 PM</li>
            </ul>
            <div className='title'>Registration Information</div>
            <ul>
                <li>5-week sessions let you and your player try rugby without a big commitment.</li>
                <li>$95 per session.</li>
                <li>Starting Sunday, October 11.</li>
                <li><b><a target="_blank" rel="noreferrer" href="https://registration.teamsnap.com/form/77203">Register on TeamSnap!</a></b></li>
            </ul>
        </>
    );
}
